import userService from '../api/user';

const handleError = (error) => {
  let result = error;

  if (typeof error.json === 'function') {
    error
      .json()
      .then((errorJson) => {
        result = errorJson;
      })
      .catch(() => {
        result = error;
      });
  } else {
    result = error;
  }

  return result;
};

export default {
  getPublicGoals: (userId) => (dispatch) => new Promise((resolve, reject) => {
    dispatch({ type: 'GET_GOALS' });
    userService
      .getPublicGoals(userId)
      .then((response) => {
        response.json().then((responseJson) => {
          dispatch({ type: 'GET_GOALS_SUCCESS', data: responseJson });
          resolve(responseJson);
        });
      })
      .catch((error) => {
        const errorInfo = handleError(error);

        dispatch({ type: 'GET_GOALS_FAIL', error: errorInfo });
        reject(errorInfo);
      });
  }),
};
